<template>
<div class="login-page">
  <!-- 科技感背景 -->
  <div class="bg-effects">
    <div class="grid-bg"></div>
    <div class="glow-orb glow-orb-1"></div>
    <div class="glow-orb glow-orb-2"></div>
    <div class="particles">
      <span v-for="i in 20" :key="i" :style="{ left: Math.random() * 100 + '%', animationDelay: Math.random() * 8 + 's', animationDuration: Math.random() * 6 + 4 + 's' }"></span>
    </div>
  </div>

  <!-- 登录卡片 -->
  <div class="login-container">
    <div class="login-card">
      <!-- Logo区域 -->
      <div class="card-header">
        <div class="logo-icon">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="1.5" opacity="0.3"/>
            <circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="1.5" opacity="0.5"/>
            <circle cx="24" cy="24" r="8" stroke="currentColor" stroke-width="1.5" opacity="0.7"/>
            <circle cx="24" cy="24" r="4" fill="currentColor" opacity="0.9"/>
            <line x1="24" y1="2" x2="24" y2="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
            <line x1="24" y1="40" x2="24" y2="46" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
            <line x1="2" y1="24" x2="8" y2="24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
            <line x1="40" y1="24" x2="46" y2="24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
          </svg>
        </div>
        <h1 class="system-title">立信鹰眼视频支撑平台</h1>
        <p class="system-sub">LXEE · 智能视频监控管理</p>
      </div>

      <!-- 表单区域 -->
      <div class="card-body">
        <!-- 用户名 -->
        <div class="input-group" :class="{ 'focused': usernameFocus, 'filled': username !== '' }">
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </span>
          <input
            type="text"
            class="input-field"
            v-model="username"
            placeholder="用户名"
            @focus="usernameFocus = true"
            @blur="usernameFocus = false"
          />
        </div>

        <!-- 密码 -->
        <div class="input-group" :class="{ 'focused': passwordFocus, 'filled': password !== '' }">
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><circle cx="12" cy="16" r="1"/></svg>
          </span>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="input-field"
            v-model="password"
            placeholder="密码"
            @focus="passwordFocus = true"
            @blur="passwordFocus = false"
          />
          <span class="toggle-pwd" @click="showPassword = !showPassword">
            <svg v-if="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          </span>
        </div>

        <!-- 登录按钮 -->
        <button class="login-btn" :class="{ loading: isLoging }" @click="login" :disabled="isLoging">
          <span v-if="!isLoging">登 录</span>
          <span v-else class="loading-spinner"></span>
        </button>
      </div>

      <!-- 底部提示 -->
      <div class="card-footer">
        <span>v2.8.6  ·  立信远大 © {{ new Date().getFullYear() }}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import crypto from 'crypto'
import userService from "./service/UserService";
export default {
  name: 'Login',
  data(){
  	return {
      isLoging: false,
      showPassword: false,
      loginLoading: false,
  		username: '',
  		password: '',
      usernameFocus: false,
      passwordFocus: false
  	}
  },
  created(){
    var that = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        that.login();
      }
    }
  },
  methods:{
  	//登录逻辑
  	login(){
  		if(this.username!='' && this.password!=''){
  			this.toLogin();
  		}
  	},

  	//登录请求
  	toLogin(){
  		//需要想后端发送的登录参数
  		let loginParam = {
  			username: this.username,
  			password: crypto.createHash('md5').update(this.password, "utf8").digest('hex')
  		}
      var that = this;
      //设置在登录状态
      this.isLoging = true;
      let timeoutTask = setTimeout(()=>{
        that.$message.error("登录超时");
        that.isLoging = false;
      }, 1000)

      this.$axios({
      	method: 'get',
        url:"/api/user/login",
        params: loginParam
      }).then(function (res) {
        window.clearTimeout(timeoutTask)
        console.log(res);
        console.log("登录成功");
          if (res.data.code === 0 ) {
            userService.setUser(res.data.data)
            //登录成功后
            that.cancelEnterkeyDefaultAction();
            that.$router.push('/');
          }else{
            that.isLoging = false;
            that.$message({
                  showClose: true,
                  message: '登录失败，用户名或密码错误',
                  type: 'error'
              });
          }
      }).catch(function (error) {
        console.log(error)
        window.clearTimeout(timeoutTask)
        that.$message.error(error.response.data.msg);
        that.isLoging = false;
      });
    },
    cancelEnterkeyDefaultAction: function() {
        document.onkeydown = function(e) {
        var key = window.event.keyCode;
        if (key == 13) {
          return false;
        }
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e8edf2 0%, #eef1f6 30%, #f5f7fa 60%, #e9eef3 100%);
  position: relative;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ========== 背景特效 ========== */
.bg-effects {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

/* 淡色网格 */
.grid-bg {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(64, 158, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(64, 158, 255, 0.04) 1px, transparent 1px);
  background-size: 80px 80px;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
}

/* 柔和光晕 */
.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(140px);
  opacity: 0.08;
}
.glow-orb-1 {
  width: 600px;
  height: 600px;
  background: #409EFF;
  top: -250px;
  left: -200px;
  animation: orbFloat1 10s ease-in-out infinite alternate;
}
.glow-orb-2 {
  width: 500px;
  height: 500px;
  background: #21d4fd;
  bottom: -200px;
  right: -150px;
  animation: orbFloat2 12s ease-in-out infinite alternate;
}

@keyframes orbFloat1 {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(50px, 40px) scale(1.08); }
}
@keyframes orbFloat2 {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(-40px, -50px) scale(1.1); }
}

/* 浮动粒子 */
.particles span {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #409EFF;
  border-radius: 50%;
  bottom: -10px;
  animation: particleRise linear infinite;
  opacity: 0;
}
@keyframes particleRise {
  0% { transform: translateY(0) scale(0); opacity: 0; }
  15% { opacity: 0.35; }
  85% { opacity: 0.1; }
  100% { transform: translateY(-100vh) scale(1); opacity: 0; }
}

/* ========== 登录容器 ========== */
.login-container {
  position: relative;
  z-index: 10;
  width: 420px;
  max-width: 90vw;
}

.login-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 48px 44px 36px;
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.06),
    0 8px 40px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s;
}
.login-card:hover {
  box-shadow:
    0 4px 20px rgba(64, 158, 255, 0.08),
    0 12px 60px rgba(0, 0, 0, 0.1);
}

/* ========== 头部 ========== */
.card-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 18px;
  color: #409EFF;
}
.logo-icon svg {
  width: 100%;
  height: 100%;
}

.system-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  letter-spacing: 1.5px;
  margin: 0 0 6px;
}
.system-sub {
  font-size: 13px;
  color: #909399;
  letter-spacing: 3px;
  margin: 0;
}

/* ========== 表单 ========== */
.card-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 输入组 */
.input-group {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #DCDFE6;
  border-radius: 8px;
  background: #F5F7FA;
  transition: all 0.25s ease;
}
.input-group:focus-within,
.input-group.focused {
  border-color: #409EFF;
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.input-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #C0C4CC;
  flex-shrink: 0;
  transition: color 0.25s;
}
.input-icon svg {
  width: 20px;
  height: 20px;
}
.input-group.focused .input-icon,
.input-group.filled .input-icon {
  color: #409EFF;
}

.input-field {
  flex: 1;
  height: 44px;
  background: transparent;
  border: none;
  outline: none;
  color: #303133;
  font-size: 14px;
  padding: 0 4px;
  font-family: inherit;
}
.input-field::placeholder {
  color: #C0C4CC;
  transition: all 0.25s;
}
.input-group.focused .input-field::placeholder {
  color: #A0CFFF;
}

.toggle-pwd {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #C0C4CC;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.25s;
}
.toggle-pwd:hover { color: #409EFF; }
.toggle-pwd svg {
  width: 18px;
  height: 18px;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #409EFF;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-top: 4px;
}
.login-btn:hover {
  background: #66B1FF;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.35);
  transform: translateY(-1px);
}
.login-btn:active {
  background: #3A8EE6;
  transform: translateY(0);
}
.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}
.login-btn:hover::before {
  left: 100%;
}
.login-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background: #A0CFFF;
}

/* Loading 动画 */
.loading-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ========== 底部 ========== */
.card-footer {
  text-align: center;
  margin-top: 28px;
}
.card-footer span {
  font-size: 12px;
  color: #DCDFE6;
  letter-spacing: 2px;
}

/* ========== 响应式 ========== */
@media (max-width: 480px) {
  .login-card {
    padding: 36px 24px 28px;
    border-radius: 12px;
  }
  .system-title {
    font-size: 17px;
    letter-spacing: 1px;
  }
  .system-sub {
    font-size: 11px;
    letter-spacing: 2px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Login.vue